module.exports = __webpack_public_path__ + "img/_airbnb.cfa9fd4f.svg";